var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"0","strokeWidth":"4","strokeLinecap":"round","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M23 61.113h14.447L44.671 45l8.886 20.071 5.835-8.483L67.722 71l7.497-20.769 5.553 10.603H93","key":0}),React.createElement("path",{"d":"M58.43 93C44.39 88.19 31.795 75.863 31.795 75.863c-17.55-18.561-8.42-37.946-8.42-37.946 10.239-21.345 35.1-4.81 35.1-4.81h.06s24.836-16.535 35.092 4.81c0 0 9.13 19.385-8.42 37.946 0 0-12.595 12.327-26.637 17.137h-.138z","key":1})]));
}

Heart.defaultProps = {"width":"114","height":"114"};

module.exports = Heart;

Heart.default = Heart;
